import { Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";

export const SimpleContent = ({
  sectionId,
  className,
  content,
  buttons,
  formId,
  successPageUrl,
}) => {
  return (
    <>
      <section id={sectionId} className={`${styles.root} ${className}`}>
        <Container>
          {content ? (
            <div
              className="mainContent"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          ) : (
            ""
          )}

          {formId ? (
            <div className="p-5 bg-white rounded-4 formWrapper">
              <SourceFlowForm
                formId={formId}
                onSubmitDone={() => (window.location.href = successPageUrl)}
              />
            </div>
          ) : (
            ""
          )}

          <Row>
            <Col className="d-flex justify-content-center">
              {buttons?.length > 0 && (
                <div className="mt-3 d-flex gap-2 flex-wrap">
                  {buttons.map(({ id, url, label, className }) => (
                    <a key={id} href={url} className={className}>
                      {label}
                    </a>
                  ))}
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SimpleContent;
